import { ExceptionService } from '../services/exception.service';
import { consoleTestResultsHandler } from 'tslint/lib/test';
import { TogetherDIPComponent } from './dip.component';
import {
  Component, Input, Output, EventEmitter, OnChanges, ViewChild,
  OnInit, SimpleChanges, AfterContentChecked,
  ElementRef, Renderer2, ChangeDetectorRef
} from '@angular/core';
import {
  UntypedFormBuilder, UntypedFormGroup, Validators,
  UntypedFormControl, AbstractControl, UntypedFormArray, FormControlDirective, FormControlName
} from '@angular/forms';
import { Router, Route, ActivatedRoute } from '@angular/router';
import {
  TogetherAuctionDIPApplicantDetails,
  TogetherAuctionDIPLoanDetails,
  TogetherAuctionDIPApplicantDetail_Request,
  TogetherAuctionDIPApplicantCompanyDetails,
} from './../models/api.models';
import { TogetherDIPStageContainer, TogetherDIPState } from './../models/app.models';
import { NodeAPIService } from './../services/node.api.service';
import { NodeAPIEntityService } from './../services/node.entity.service';
import {
  TogetherAuctionDIPEntityType,
  TogetherAuctionDIPEntityOperation
} from './../models/enums';
import * as _ from 'lodash-es';


@Component({
    selector: 'together-auction-dip-applicant-details',
    templateUrl: './dip.applicant_details.component.html',
    providers: [NodeAPIService, NodeAPIEntityService],
    standalone: false
})
export class TogetherAuctionDIPApplicantDetailsComponent implements OnInit {

  tad_business_personal: UntypedFormControl = new UntypedFormControl(null, [Validators.required]);
  tad_business: UntypedFormGroup = new UntypedFormGroup({});
  hasSearched: UntypedFormControl = new UntypedFormControl('', [
    // Validators.required,
  ]);
  applicantDetailsParentForm: UntypedFormGroup = this.fb.group({
    hasSearched: this.hasSearched,
    tad_business_personal: this.tad_business_personal,
    tad_business: this.tad_business,
    tad_applicants: this.fb.array([]),
  });

  @ViewChild('inputRef') inputRef;

  @Input() incoming_case_id: string;

  @Input() stage: TogetherDIPStageContainer;
  @Output() applicant_added = new EventEmitter();
  @Output() stage_changing = new EventEmitter();
  @Output() saving_applicants = new EventEmitter();
  applicantsSubDetails: Array<object> = [];
  _notifications: Array<object> = [];
  applicants: Array<TogetherAuctionDIPApplicantDetails> = [];
  business_applicant: TogetherAuctionDIPApplicantCompanyDetails;
  saved_applicants: Array<boolean> = [];
  _do_save: boolean = false;
  _next: boolean = false;
  hasLived3yearSelected: boolean = false;
  _currentState: number = TogetherDIPState.New;
  collapseAllApplicant: boolean = false;

  _componentsLoading = {
    businessApplicant: false,
    applicants: [],
    applicantDetails: false,
  };
  __isLoading: boolean = false;
  _isSubmitting: boolean = false;
  isSubmitted: boolean = false;
  sequence: number;
  _isTogglingBusinessApplicant: boolean = false;
  _startIndex = 1;
  hasTitleNotSelected: boolean = false;
  IsPostCodeNotEntered: boolean = false;
  IsBusinessPostCodeNotEntered: boolean = false;
  doSaveBusinessApp: boolean = false;
  private formSubmitAttempt: boolean;
  savedArray: Array<boolean> = [];

  set _isLoading(val) {
    this._componentsLoading['applicantDetails'] = val;
  }

  get _isLoading() {
    const loadingElements = _.transform(this._componentsLoading, (result, value, key) => {
      if (key === 'applicants') {
        const elems = _.toArray(value);
        const loading = _.filter(elems, (item) => {
          return item;
        });
        result.push(loading.length > 0);
      } else {
        result.push(value);
      }
    }, []);
    return loadingElements.indexOf(true) !== -1;
  }

  updateLoadingStatusFromChild(status) {

    const component = status.component;

    // Find out what's updating.
    const componentExists = this._componentsLoading[component];

    // Whoever you are, you updated something and broke it.. bad boy.
    if (_.isNil(componentExists) === true) {
      return;
    }

    const loading = status.status;

    if (component === 'applicants') {
      const iter = status.parameter;
      this._componentsLoading[component][iter] = loading;
    } else {
      this._componentsLoading[component] = loading;
    }
  }

  set isLoading(val) {
    if (val === this._isLoading) {
      return;
    }
    this._componentsLoading['applicantDetails'] = val;
  }

  get _showAction() {
    const lastIndex = this.getLastApplicantIndex();
    return ((this.isCompanyApplication === true && lastIndex < 5) ||
      (this.isCompanyApplication === false && lastIndex < 4) &&
      this.tad_business_personal.value !== null);
  }

  get isCompanyApplication() {
    return this.tad_business_personal.value === 'business';
  }

  get hasDeletableCompanyApplication() {
    return _.isNil(this.business_applicant) === false &&
      this.api.isNew(this.business_applicant.Id) === false;
  }


  _setErrorNotifications(notifications) {
    this._notifications = notifications;
  }

  get BusinessDetails() {
    return this.fb.group({
      tad_business: this.applicantDetailsParentForm.get('tad_business'),
      tad_business_personal: this.applicantDetailsParentForm.get('tad_business_personal'),
    });
  }

  get DisplayApplicants() {
    return _.filter(this.applicants, (app) => {
      return _.isNil(app) === false;
    });
  }

  _handleDeleteBusinessApplicant() {
    this.savedArray = [];
    this.api.deleteEntities(
      TogetherAuctionDIPEntityType.ApplicantsPersonal,
      TogetherAuctionDIPEntityOperation.Delete,
      this.incoming_case_id,
      this.business_applicant.Id)
      .subscribe(
        (success) => {
          this._isLoading = false;
        },
        (error) => {
          this.exception.haveReceivedError(error);
        },
      );
  }

  _clearErrors() {
    this._notifications = [];
  }

  _handleError(error) {
    this._notifications.push({ text: error.error.message });
  }

  _handleIncomingFormUpdate(form) {
    this.applicantDetailsParentForm.setControl('tad_business', form);
  }

  deleteApplicantBySequence(seq) {
    this.collapseAllApplicant = false;
    const apps = _.transform(this.applicants, (iter, n) => {
      if (_.isNil(n)) {
        return true;
      }
      const thisSeq = n.Instance.ApplicantSequence;
      if (thisSeq !== seq) {
        iter[thisSeq] = n;
      }
      return true;
    }, []);
    this.applicants = apps;
  }

  deleteAPIApplicantById(id, iterator) {
    this.applicants = this.applicants.filter(x => x.Instance.Id !== id);
    this.collapseAllApplicant = false;
    this.api.deleteEntities(
      TogetherAuctionDIPEntityType.ApplicantsPersonal,
      this.incoming_case_id, id)
      .subscribe(
        (success) => {

        },
        (error) => {
          this.exception.haveReceivedError(error);
        },
      );
    this.deleteApplicantBySequence(iterator);
    this.rebuildApplicantForm(iterator);
  }

  rebuildApplicantForm(id) {
    // Get applicants from form array.
    const apps: UntypedFormArray = this.applicantDetailsParentForm.get('tad_applicants') as UntypedFormArray;

    // Get controls so we can then remove the id we got.
    const controls = apps.controls;

    // Transform controls
    const reordered = _.transform(controls, (iter, n: UntypedFormControl) => {

      // Get the applicant number from the form group.
      const appNumber = n.get('tad_address_applicant_number').value;

      if (appNumber !== id) {
        iter.push(n);
      }
      return true;
    }, []);

    // Now rebuild the array.
    this.applicantDetailsParentForm.setControl('tad_applicants', this.fb.array(reordered));
  }


  getOrderedApplicants() {
    return _.transform(this.applicants, (iter, n) => {
      const applicant: TogetherAuctionDIPApplicantDetails = n;
      if (_.isNil(applicant) === false) {
        const seq = applicant.Instance.ApplicantSequence;
        iter.apps[seq] = applicant;
        iter.seqs[seq] = seq;
      }
      return true;
    }, {
      seqs: [],
      apps: [],
    });
  }

  reOrderApplicants() {
    // Get the applicants ordered.
    const applicantsOrdered = this.getOrderedApplicants();
    const applicants = applicantsOrdered.seqs.slice(1);
    const isAscending = applicants =>
      applicants.slice(1).map((e, i) => e > applicants[i])
        .every(x => x);
    if (!isAscending(applicants)) {
      const apps = _.transform(
        applicantsOrdered.apps,
        (iter, n: TogetherAuctionDIPApplicantDetails) => {
          if (_.isNil(n)) {
            return true;
          }
          const seq = n.Instance.ApplicantSequence;
          if (seq === 1) {
            iter[seq] = n;
          }
          if (seq > 1) {
            n.Instance.ApplicantSequence = seq - 1;
            iter[seq - 1] = n;
          }
          return true;
        }, []);

      this.applicants = apps;
    }
  }


  _handleChildDeleted(obj_info) {
    const iterator = obj_info['iterator'];
    const id = obj_info['applicant_id'];

    if (this.api.isNew(id) === false) {
      this.deleteAPIApplicantById(id, iterator);
    } else {
      this.deleteApplicantBySequence(iterator);
      this.rebuildApplicantForm(iterator);
    }
    this.savedArray = [];

    this.reOrderApplicants();

    /**const applicants: FormArray =
        this.applicantDetailsParentForm.get('tad_applicants') as FormArray;

    const all_apps = applicants.controls;
    const app_len = all_apps.length - 1;
    const new_arr = [];
    const new_app = [];

    for (let i = 0; i <= app_len; i++) {
      if (i !== iterator) {
        new_arr.push(all_apps[i]);
        new_app.push(this.applicants[i]);
      }
    }

        // Sets the array back in the form
    this.applicantDetailsParentForm.setControl('tad_applicants',this.fb.array(new_arr));
    this.applicants = new_app;**/
  }

  _handleEquifaxError(error) {
    this.exception.haveReceivedError(error);
  }

  _handleFormFromChild(in_form: UntypedFormGroup) {

    // Get the sequence of the child.
    const seq = _.toInteger(in_form.get('tad_address_applicant_number').value) - 1;

    // Get the applicants array.
    const apps = this.applicantDetailsParentForm.get('tad_applicants') as UntypedFormArray;

    // Remove the existing app array.
    apps.removeAt(seq);

    // Insert the form array back
    apps.insert(seq, in_form);

    // Insert it back.
    this.applicantDetailsParentForm.setControl('tad_applicants', apps);
  }

  _handleSave() {
    if (this.applicantDetailsParentForm.valid) {
      this._do_save = true;
    }
  }

  _handleAddressSelectDisplayed() {
    this._isLoading = false;
  }

  /**
     * Passed back from the DIPApplicantComponent to say applicant was saved.
     *
     * @param {any} applicant
     * @memberof TogetherAuctionDIPApplicantDetailsComponent
     */
  _handleApplicantSaveSuccess(applicant) {
    this._do_save = false;
    this._isLoading = false;

    this.saved_applicants[applicant.iterator] = true;
    // Filter those which have this applicant sequence.
    const filterApplicants = this.applicants.filter((x) => {
      if (_.isNil(x) === false) {
        return x.Instance.ApplicantSequence === this.sequence;
      }
    });

    // If there are none, we don't move forward
    const hasApplicants = _.isNil(filterApplicants) === false;

    // if (is_saved.length === this.DisplayApplicants.length) {
    if (hasApplicants) {
      this._handleDeleteBusinessApplicantIfDeselected();
      this.stage_changing.emit(this.stage.current_stage.forward_reference);
    }
  }


  _handleDisableButtons() {
    return this.applicantDetailsParentForm.invalid === true;
  }

  _handleInitDefaultData() {
    const primary_applicant = this.applicants[0].Instance;
    const isCompany = primary_applicant.IsCompanyApplication;
    this.tad_business_personal.setValue(isCompany ? 'business' : 'personal');
  }

  _handleApplicantReorder() {

    const apps: Array<TogetherAuctionDIPApplicantDetails> = this.applicants.slice(1);

    if (_.isEmpty(apps) === true) {
      return;
    }

    // Re-order the applicants so they are in order.
    const applicantsOrdered = _.transform(apps, (iter, n) => {
      const applicant: TogetherAuctionDIPApplicantDetails = n;
      if (_.isNil(applicant) === false) {
        const seq = applicant.Instance.ApplicantSequence;
        iter.apps[seq] = applicant;
        iter.seqs[seq] = seq;
      }
      return true;
    }, {
      seqs: [],
      apps: [],
    });

    // Now, has some cheeky chappy/chapesse managed to mess with the order?
    const expectedSeq = [null, 1, 2, 3, 4];

    if (this.isCompanyApplication) {
      const hasApp1 = applicantsOrdered.seqs.indexOf(1) !== -1;
      if (hasApp1) {
        const allApps = applicantsOrdered.apps.slice(1);
        const applicantsReordered = _.transform(allApps, (iter, n) => {
          const applicant: TogetherAuctionDIPApplicantDetails = n;
          const seq = applicant.Instance.ApplicantSequence;
          const inc = seq + 1;
          if (inc !== 0) {
            applicant.Instance.ApplicantSequence = inc;
            iter[inc] = applicant;
          }
          return true;
        }, []);
        this.applicants = applicantsReordered;
        this._startIndex = 2;
      }
    } else {
      const hasNoApp1 = applicantsOrdered.seqs.indexOf(1) !== 1;
      if (hasNoApp1) {
        const allApps = applicantsOrdered.apps.slice(2);
        const applicantsReordered = _.transform(allApps, (iter, n) => {
          const applicant: TogetherAuctionDIPApplicantDetails = n;
          const seq = applicant.Instance.ApplicantSequence;
          const inc = seq - 1;
          if (inc !== 0) {
            applicant.Instance.ApplicantSequence = inc;
            iter[inc] = applicant;
          }
          return true;
        }, []);
        this.applicants = applicantsReordered;
        this._startIndex = 1;
      }
    }
    this._isLoading = false;
    this.ref.detectChanges(); // Prevent ChangedAfterChecked error.
  }

  _handleInitData(case_id) {
    this._isLoading = true;
    this.api.getAllEntities(TogetherAuctionDIPEntityType.ApplicantsPersonal, case_id)
      .subscribe(
        (success) => {
          // HACK HACK HACK HACK HACK - this should be fixed in Broker API, but...
          if (_.isNil(success['Error']) === true && _.isArray(success) && (success as Array<any>).length > 0) {

            let isBusiness = false;

            // Get applicants.
            const applicants = _.filter(success, (app) => {
              return _.isNil(app.LegalBodyRoleTypeId) ? false : app.LegalBodyRoleTypeId === 1 ||
                app.LegalBodyRoleTypeId === 5;
            });

            // Get business applicants.
            const businessApplicants = _.filter(success, (app) => {
              return _.isNil(app.LegalBodyRoleTypeId) ? false : app.LegalBodyRoleTypeId === 2;
            });

            // Chop off business applicant.
            if (businessApplicants.length >= 1) {
              this.business_applicant = new TogetherAuctionDIPApplicantCompanyDetails(
                businessApplicants[0],
              );
              isBusiness = true;
            }

            // Clear the applicants out.
            this.applicants = [];

            // Loop each applicant, add in based on applicant sequence
            _.each(applicants, (app) => {
              const seq = app.ApplicantSequence;
              this.applicants[seq] = new TogetherAuctionDIPApplicantDetails(seq, app);
            });

            this.tad_business_personal.setValue(isBusiness ? 'business' : 'personal');
            this.tad_business_personal.disable();

            // Prevent unlucky duckies from mucking with stuff.. :)
            this._handleApplicantReorder();
          } else {
            this.applicants = [
              null,
              new TogetherAuctionDIPApplicantDetails(1),
            ];
            this.tad_business_personal.enable();
          }

          // TODO: Chop off business applicant if it exists on the first element.

          this._isLoading = false;
          this._clearErrors();
        },
        (error) => {
          this.exception.haveReceivedError(error);
          this._isLoading = false;
          this.applicants = [
            null,
            new TogetherAuctionDIPApplicantDetails(1),
          ];
          this.tad_business_personal.setValue(
            this.isCompanyApplication ? 'business' : 'personal',
          );
        },
      );
  }

  _handleInit() {
    this.savedArray = [];
    this.applicantDetailsParentForm.get('tad_business_personal').valueChanges.subscribe((val) => {
      if (val === 'personal') {
        this.applicantDetailsParentForm.get('tad_business').disable();
      } else {
        this.applicantDetailsParentForm.get('tad_business').enable();
      }
    });
    // Is the entity not new? If so, let's get the details.
    if (this.api.isNew(this.incoming_case_id) === false) {
      this._handleInitData(this.incoming_case_id);
    } else {
      // If we're not allowed to have a new reference, move.
      if (this.api.allowNew(this.stage.current_stage.reference) === false) {
        this.stage_changing.emit('tad_stage_info');
      }
    }

  }

  /**
   * Gets applicants from API to update.
   *
   * @memberof TogetherAuctionDIPApplicantDetailsComponent
   */
  ngOnInit() {
    window.scrollTo(0, 0);
    // this.ref.detach();
    this._handleInit();
  }

  /**
   * The child form transmits its formGroup to the parent, parent updates applicant details.
   *
   * @param {any} form_group
   * @memberof TogetherAuctionDIPApplicantDetailsComponent
   */
  _handleChildUpdated(form_group) {
    this.applicantsSubDetails[form_group.index - 1] = form_group.form;
    const fa = this.fb.array(this.applicantsSubDetails);
    this.applicantDetailsParentForm.setControl('tad_applicants', fa);
  }


  getLastApplicantIndex() {
    const applicantsOrdered = _.transform(this.applicants, (iter, n) => {
      const applicant: TogetherAuctionDIPApplicantDetails = n;
      if (_.isNil(applicant) === false) {
        const seq = applicant.Instance.ApplicantSequence;
        iter[seq] = seq;
      }
      return true;
    }, []);
    return _.max(applicantsOrdered);
  }

  _addApplicant() {

    // Get last index of applicants.
    const lastIndex: number = this.getLastApplicantIndex();

    // Now check if we actually can add any more applicants.
    if ((this.isCompanyApplication === true && lastIndex >= 5) ||
      (this.isCompanyApplication === false && lastIndex >= 4)) {
      this.addNotification(
        this.isCompanyApplication ?
          'You cannot add more than 3 applicants to a business application' :
          'You cannot add more than 4 applicants to an application.',
      );
    } else {
      const addIndex = lastIndex + 1;
      this.applicants.push(
        new TogetherAuctionDIPApplicantDetails(addIndex));
    }
  }

  /**
   * Sets the applicants for the form array.
   *
   * @param {TogetherAuctionDIPApplicantDetails[]} applicants
   * @memberof TogetherAuctionDIPApplicantDetailsComponent
   */
  setApplicants(applicants: TogetherAuctionDIPApplicantDetails[]) {

    // Map the applicant form groups.
    const applicantFormGroups = this.applicants.map(applicant => this.fb.group(applicant));

    // Updates the form array.
    const applicantFormArray = this.fb.array(applicantFormGroups);

    // Update
    this.applicantDetailsParentForm.setControl('applicants', applicantFormArray);
  }


  /**
   * TODO: Error handler.
   *
   * @param {any} error
   * @returns
   * @memberof TogetherAuctionDIPApplicantDetailsComponent
   */
  _handleApplicantSaveError(error) {
    this._do_save = false;
    this._isLoading = false;
    this._next = false;
    return; // TODO: add error handling.
  }

  /**
   * Handles when the action is clicked to add a new applicant.
   * (Sets _saving, which triggers applicant to save)
   *
   * @memberof TogetherAuctionDIPApplicantDetailsComponent
   */
  _handleAddApplicantSave() {
    this._isLoading = true;
    this._do_save = true;
  }

  /*
   * Adds the applicant to the case.
   *
   * @memberof TogetherAuctionDIPApplicantDetailsComponent
   */
  _handleAddApplicant() {
    this.applicant_added.emit(true);
  }

  _handleApplicantPreviousApplicantSave($event) {
    this.applicantDetailsParentForm.get('tad_business_personal').disable();
    this.savedArray.push($event.isPreviousApplicantSaved);
    if (this.DisplayApplicants.length === this.savedArray.length) {
      this._do_save = false;
      this.doSaveBusinessApp = false,
        this.collapseAllApplicant = false;
      this._addApplicant();
    }
  }

  /**
   * Handle move backward.
   *
   * @param {any} backward
   * @memberof TogetherAuctionDIPApplicantDetailsComponent
   */
  _handleBackward(backward) {
    this.stage_changing.emit(this.stage.backward_stage.reference);
  }

  _handleDeleteBusinessApplicantIfDeselected() {
    if (this.hasDeletableCompanyApplication && this.tad_business_personal.value === 'personal') {
      this._handleDeleteBusinessApplicant();
    }
  }

  /**
   * Handles move forward.
   *
   * @param {any} forward
   * @memberof TogetherAuctionDIPApplicantDetailsComponent
   */
  _handleForward(forward) {
    this._isSubmitting = true;
    this.isSubmitted = true;
    if (this._handleCanProgressForward()) {
      this._isLoading = true;
      if (this.applicantDetailsParentForm.get('tad_business_personal').value === 'business') {
        this.doSaveBusinessApp = true;
      } else {
        this._do_save = true;
      }
    } else {
      this.validateAllFormFields(this.applicantDetailsParentForm);
      this.addNotification('Please fill in all required fields.');
    }
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPApplicantDetailsComponent
   */
  ngAfterViewChecked() {
    if (this.isSubmitted) {
      const element = this.elementRef.nativeElement.querySelector('.is-invalid');
      if (!_.isNil(element)) {
        element.scrollIntoView();
        this.isSubmitted = false;
      }
    }
  }

  /**
   *
   *
   * @param {any} isBusinessApplicantSave
   * @memberof TogetherAuctionDIPApplicantDetailsComponent
   */
  handleBusinessAppSaveSuccess(isBusinessApplicantSaved) {
    if (isBusinessApplicantSaved) {
      this._do_save = true;
      this.doSaveBusinessApp = false,
        this.applicantDetailsParentForm.get('tad_business_personal').disable();
    }
  }
  addNotification(title) {
    this._notifications = [];
    this._notifications.push({ text: title });
  }

  _handleCanProgressForward() {
    return this.applicantDetailsParentForm.valid;
  }

  /**
   * Handle addition of new applicant.
   *
   * @param {any} action
   * @memberof TogetherAuctionDIPApplicantDetailsComponent
   */
  _handleAction(action) {
    if (this._handleDisableButtons() === false) {
      this.collapseAllApplicant = true;
      this.savedArray = [];
      this._isLoading = true;
      if (this.applicantDetailsParentForm.get('tad_business_personal').value === 'business') {
        this.doSaveBusinessApp = true;
      } else {
        this._do_save = true;
      }
    } else {
      this.validateAllFormFields(this.applicantDetailsParentForm);
      this.addNotification('Please fill in all required fields.');
    }
  }

  checkApplicantsReordered() {
    const applicantsOrdered = _.transform(this.applicants, (iter, n) => {
      const applicant: TogetherAuctionDIPApplicantDetails = n;
      if (_.isNil(applicant) === false) {
        const seq = applicant.Instance.ApplicantSequence;
        iter[seq] = seq;
      }
      return true;
    }, []);
    const order = applicantsOrdered.slice(1);
    const limit = order.length - 1;
    const empties = _.filter(applicantsOrdered, app => _.isNil(app));
    const hasEmpty = empties.length > 0;
    return hasEmpty === false &&
      order.every((_, i) => (i < limit ? order[i] <= order[i + 1] : true));
  }

  checkBusinessApplicantReorder() {
    if (this.DisplayApplicants.length === 1 && this.tad_business_personal.value === 'business') {

      const app = this.applicants[1];

      if (_.isNil(app)) {
        return false;
      }
      const applicantIterator = app.Instance.ApplicantSequence;
      return applicantIterator === 1;
    }
    return false;
  }


  _handleToggleBusinessApplicant() {

    if (this.applicants.length < 1) {
      return;
    }

    // This is one area where TSlint makes code ugly.
    const bus = this.checkBusinessApplicantReorder();
    const ord = this.checkApplicantsReordered();

    if (bus === true || ord === false) {
      this._handleApplicantReorder();
    }
  }

  ngAfterContentChecked() {
    this._handleToggleBusinessApplicant();
  }


  handleSavedApplicant(form) {

  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    const self = this;
    self.IsPostCodeNotEntered = false;
    Object.keys(formGroup.controls).forEach((field) => {

      const control = formGroup.get(field);

      if (field === 'tad_lived_three_year') {
        if (control instanceof UntypedFormControl && _.isNil(control.value)) {
          self.hasLived3yearSelected = true;
        }
      } else if (field === 'tad_applicant_title') {
        if (control instanceof UntypedFormControl && _.isEmpty(control.value)) {
          self.hasTitleNotSelected = true;
        }
      } else if (field === 'tad_applicant_address') {
        if (control instanceof UntypedFormGroup && _.isEmpty(control.controls)) {
          self.IsPostCodeNotEntered = true;
        }
      } else if (self.tad_business_personal.value === 'business'
        && field === 'tad_company_address') {
        if (control instanceof UntypedFormGroup && _.isEmpty(control.controls)) {
          self.IsBusinessPostCodeNotEntered = true;
        }
      } else if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      } else if (control instanceof UntypedFormArray) {
        const controlAsFormArray = control as UntypedFormArray;
        controlAsFormArray.controls.forEach((arrayControl: UntypedFormGroup) =>
          this.validateAllFormFields(arrayControl));
      }
    });
    // element.focus();
  }
  /**
   * Creates an instance of TogetherAuctionDIPApplicantDetailsComponent.
   * @param {NodeAPIService} api
   * @memberof TogetherAuctionDIPApplicantDetailsComponent
   */
  constructor(
    private api: NodeAPIEntityService,
    private fb: UntypedFormBuilder,
    private elementRef: ElementRef,
    private ref: ChangeDetectorRef,
    private rend: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    private exception: ExceptionService) { }
}
